import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSingleArtwork } from '../store/actions/artwork'
import ReactLoading from "react-loading";

function Detail() {
  let { id } = useParams()
  const singleArtwork = useSelector(state => state.artwork.artwork)
  const loading = useSelector(state => state.artwork.loading)
  const error = useSelector(state => state.artwork.error)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchSingleArtwork(id))
  }, [id, dispatch])

  let element = null
  let altText

  if (singleArtwork) {
    if (singleArtwork.data.thumbnail) {
      altText = singleArtwork.data.thumbnail.alt_text
    } else {
      altText = 'no alt text available'
    }
    const iiif_url = singleArtwork.config.iiif_url
    singleArtwork.data.imageUrl = iiif_url + '/' + singleArtwork.data.image_id + '/full/843,/0/default.jpg'
    element = (
      <div>
        <div className="row justify-content-center bg-dark py-3">
          <div className="col-6 text-center" id="image-container">
            <img
              src={singleArtwork.data.imageUrl}
              className="img-fluid mh-100"
              alt={altText}
            />
          </div>
        </div>
        <div className="container mt-2">
          <div className="row justify-content-center">
            <div className="col-8">
              <div className="card">
                <div className="card-body">
                  <h3 className="card-title mb-5">{singleArtwork.data.title}</h3>
                  <h5 className="card-subtitle text-muted mb-3">{singleArtwork.data.date_display}</h5>
                  <h5 className="card-subtitle text-muted mb-4">{singleArtwork.data.artist_display}</h5>
                  <h5 className="card-subtitle mb-4">Provenance:</h5>
                  {
                    singleArtwork.data.provenance_text ? 
                      <p className="card-subtitle mb-4">{singleArtwork.data.provenance_text}</p>
                      :
                      <p>No provenance text available</p>
                  }
                  <table className="table">
                    <tbody>
                      <tr>
                        <th>Artist</th>
                        <td>{singleArtwork.data.artist_title}</td>
                      </tr>
                      <tr>
                        <th>Title</th>
                        <td>{singleArtwork.data.title}</td>
                      </tr>
                      <tr>
                        <th>Origin</th>
                        <td>{singleArtwork.data.place_of_origin}</td>
                      </tr>
                      <tr>
                        <th>Date</th>
                        <td>{singleArtwork.data.date_start} - {singleArtwork.data.date_end}</td>
                      </tr>
                      <tr>
                        <th>Dimensions</th>
                        <td>{singleArtwork.data.dimensions}</td>
                      </tr>
                      <tr>
                        <th>Medium</th>
                        <td>{singleArtwork.data.medium_display}</td>
                      </tr>
                      <tr>
                        <th>Credit Line</th>
                        <td>{singleArtwork.data.credit_line}</td>
                      </tr>
                      <tr>
                        <th>Copyright</th>
                        <td>{singleArtwork.data.copyright_notice}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      {
        error ? <p>Something went wrong.</p> : null
      }
      {
        loading ?
          <div className="vh-100">
            <div className="position-absolute top-50 start-50 translate-middle">
              <ReactLoading type="spin" color="#0f0f0f"/>
            </div>
          </div>
          :
          singleArtwork ?
            element
            :
            null
      }
      {/* {data.data.title} */}
    </div>
  )
}

export default Detail